import { useEffect, useState } from 'react';
import { useWeb3React } from '@web3-react/core';

import useNoundleStakingPool from './useNoundleStakingPool';

const useStakedNoundles = () => {
  const { account } = useWeb3React();
  const stakingPool = useNoundleStakingPool();

  const [stakedNoundles, setStakedNoundles] = useState([]);

  useEffect(() => {
    let ignore = false;
    setStakedNoundles([]);
    if (stakingPool) {
      const fetchStakedNoundles = () => {
        stakingPool.stakedTokens(account).then((tokenIds) => {
          if (!ignore)
            setStakedNoundles(tokenIds.map((tokenId) => tokenId.toNumber()));
        });
      };
      fetchStakedNoundles();
      const stake = stakingPool.filters.Stake(account);
      const unstake = stakingPool.filters.Unstake(account);

      stakingPool.on(stake, fetchStakedNoundles);
      stakingPool.on(unstake, fetchStakedNoundles);

      return () => {
        stakingPool.off(stake, fetchStakedNoundles);
        stakingPool.off(unstake, fetchStakedNoundles);
        ignore = false;
      };
    }
  }, [stakingPool, account]);

  return stakedNoundles;
};

export default useStakedNoundles;
